import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [  "rangeValue",
                      "rangeValueOutput",
                    ]
  static values = {
    setValue: Number
  }

  initialize() {
  }

  updateRangeValueOutput() {
    this.rangeValueOutputTarget.value = this.rangeValueTarget.value;
  }

  setValueOutput(event) {
    event.preventDefault();   
    const valueToSet = this.setValueValue || 0;
    this.rangeValueTarget.value = valueToSet;
    this.rangeValueOutputTarget.value = valueToSet;
  }
}
